<mat-sidenav-container>
	<mat-sidenav #drawer fixedInViewport role="dialog" mode="over">
		<app-drawer [drawer]="drawer"></app-drawer>
	</mat-sidenav>
	<mat-sidenav-content>
		<app-header [drawer]="drawer"></app-header>
		<router-outlet></router-outlet>
		<app-footer></app-footer>
	</mat-sidenav-content>
</mat-sidenav-container>
<app-cookie-consent></app-cookie-consent>
